// extracted by mini-css-extract-plugin
export default {"songCard":"MainPage_songCard__VocAO","lyricsPreview":"MainPage_lyricsPreview__DYtPS","songCardImage":"MainPage_songCardImage__YAeAb"};